import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { Configuration } from '../../../../../core/av-api';
import { BatchAuftragService, SelektionskriterienDetailEntryMeta } from '../../../../../core/batch-auftrag-api';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CapAlertService } from '../../../../../core/extension/exceptions/cap-alert.service';
import { CapAlertLevel } from '../../../../../core/extension/exceptions/cap-alert-level.enum';
import { MetaDisablerDirective } from '../../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../../shared/directives/meta-validator.directive';

@Component({
  selector: 'cap-auftrag-grundstueck-identifikatoren-selection',
  templateUrl: './auftrag-grundstueck-identifikatoren-selection.component.html',
  styleUrls: ['./auftrag-grundstueck-identifikatoren-selection.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AuftragGrundstueckIdentifikatorenSelectionComponent),
      multi: true
    }
  ],
  imports: [FormsModule, MetaDisablerDirective, MetaValidatorDirective, TranslatePipe]
})
export class AuftragGrundstueckIdentifikatorenSelectionComponent implements OnInit, ControlValueAccessor {
  public configuration = new Configuration();

  propagateChange: (id: string) => void;
  propagateTouch: (_) => void;

  selektionskriterien: SelektionskriterienDetailEntryMeta;

  @Input()
  readonly: boolean;

  @Input()
  fileName: string | undefined;

  constructor(
    private capAlertService: CapAlertService,
    private translate: TranslateService,
    private batchAuftragService: BatchAuftragService
  ) {}

  ngOnInit() {}

  writeValue(obj: SelektionskriterienDetailEntryMeta) {
    if (obj) {
      this.selektionskriterien = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.propagateTouch = fn;
  }

  onFileChange(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.batchAuftragService.validateGrundstueckExportFile(file, file.name).subscribe(
        () => {
          const fileReader = new FileReader();
          fileReader.onload = (e) => {
            const fileContent = fileReader.result as string;
            this.selektionskriterien.fileSelection = {
              fileName: file.name,
              fileContent: fileContent
            };
          };
          fileReader.readAsText(file);
        },
        (error) => {
          if (error.status === 400) {
            const params = { fehlerMeldung: this.translate.instant('EingabeUploadFileNichtValidOderNameExistiert') };
            this.capAlertService.warning(this.translate.instant('ValidierungsFehler', params), CapAlertLevel.CONTENT_HEADER);
          }
        }
      );
    }
  }
}
